import { ProfiloVO } from "@app/shared/vo/profiloVO";
import { ClassificaDTO } from "../dto/classificaDTO";
import { StrutturaVO } from "./strutturaVO";
import { TipoIstanzaFascicoloVO } from "./tipo-istanza-fascicoloVO";

export class MetadatiFascicoloVO {
  idFascicolo: string;

  segnaturaArchivistica: string;

/*   tipologia: TipoIstanzaFascicoloVO;

  classifica: ClassificaDTO;

  oggetto: string; */
}
